var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLikedFolder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#liked_folder_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#liked_folder_svg__b)",
  d: "M0 0h36v36H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#090C0F",
  fillOpacity: 0.05,
  d: "M0 0h36v36H0z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.995 11.097c-1.95-1.704-4.834-2.052-7.073-.139-2.423 2.07-2.775 5.555-.86 8.02.728.936 2.147 2.342 3.511 3.629a154.512 154.512 0 0 0 3.435 3.134l.013.012c.064.056.144.127.22.184.09.069.222.154.397.206.232.07.482.07.714 0 .175-.052.306-.137.397-.206a3.72 3.72 0 0 0 .22-.184l.013-.012a154.24 154.24 0 0 0 3.435-3.134c1.364-1.287 2.783-2.693 3.51-3.629 1.908-2.455 1.61-5.968-.867-8.027-2.265-1.882-5.118-1.558-7.065.146Z",
  fill: "#F9F9F9"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 35,
  rx: 17.5,
  stroke: "#fff",
  strokeOpacity: 0.15
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "liked_folder_svg__b",
  x1: 18,
  y1: 0,
  x2: 18,
  y2: 36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D2215A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#811034"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "liked_folder_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("image", {
  id: "liked_folder_svg__c",
  width: 64,
  height: 64,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAONJREFUeF7t20EOhEAIRFG4/6F7DvEnYeFzryQIv6pBd2behOu9dPvsbog+k+NLgArQAqmJcw9iAAhSgZKB3IJkkAySQTJ4CiE+gA8oBeg0mH3Ai084P89HhqwEqIA209ICsQdjAeaZIgaAYKxBDMCAYy8fXwAIgiAIcoJpJEYGI4VjB3YrbC9gL2AvkCB43cM5PgZgAAZgQFnNZAhdGykQBEEQBEEQDBmgAm2glM/z+QUYisYUGoldO7kY32IEAzCg6RgIRgjFAsw+AgRBMNYgBmCAT2TCYfoPPz/HCqQCX1eBHzHnv7C7WhBSAAAAAElFTkSuQmCC"
}))));
export default SvgLikedFolder;